import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './CheckBox.module.scss';

const CheckBox = ({
  company,
  handleCheck,
  isSelected,
  allCheck,
  disabled = false
}) => {
  return (
    <>
      {allCheck === 'none' ? (
        <div className={classes.nullContainer}></div>
      ) : (
        <div
          className={cn(classes.optionWrap, disabled && classes.disabled)}
          onClick={disabled ? undefined : () => handleCheck(company)}
        >
          <div
            className={cn(
              classes.checkBox,
              isSelected && classes.checkBox_selected
            )}
          >
            {!allCheck && isSelected ? (
              <div className={classes.arrow} />
            ) : (
              allCheck === '-' && allCheck
            )}
          </div>
        </div>
      )}
    </>
  );
};

CheckBox.propTypes = {
  company: PropTypes.object,
  handleCheck: PropTypes.func.isRequired,
  isSelected: PropTypes.object,
  allCheck: PropTypes.string,
  disabled: PropTypes.bool
};

export default CheckBox;
